module.exports = __webpack_public_path__ + "img/noti3.11f60e4b.jpeg";